module.exports = __webpack_public_path__ + "img/video_cover.e81c9311.jpg";